import { Component } from '@angular/core';
import { MasipService } from '../../services/masip.service';
import { AuthService } from '../../services/auth.service';
@Component({
    selector: 'app-settings-profiles',
    templateUrl: './settings-profiles.component.html',
    styleUrl: './settings-profiles.component.scss',
    standalone: false
})
export class SettingsProfilesComponent {

  showDetails: boolean = false;
  profiles: any;
  selectedProfile: any;

  constructor(private masipService: MasipService, private authService: AuthService) { };

  ngOnInit() {
    this.masipService.setApiLoadingGlobal(false);
    this.getProfilesByUser();
    
  }

  getProfilesByUser() {
    var fiscalId = '';
    if (localStorage.getItem('accessAsUser') !== null) {
      fiscalId = String(localStorage.getItem('accessAsUser') || '');
    }
    this.masipService.setApiLoadingGlobal(true);
    this.masipService.getProfilesByUser(fiscalId).subscribe((resp: any) => {
      this.masipService.setApiLoadingGlobal(false);
      this.profiles = resp;
    }, (error: any) => {
      this.masipService.setApiLoadingGlobal(false);
      console.log(error);
    })
  }

  openDetails(profile: any) {
    // this.lineInfo = element;
    this.showDetails = true;
    this.selectedProfile = profile;
  }

  createProfile() {
    this.selectedProfile = undefined;
    this.showDetails = true;
  }

  changeDetails(nuevoEstado: boolean) {
    this.showDetails = nuevoEstado;
    this.getProfilesByUser();
    
  }
}
